/* Slick carousel init removed 2026-09-07 — the USP strip (usp.liquid) and image gallery
   (image-gallery.liquid) now use native CSS scroll-snap instead of the Slick jQuery plugin.
   jQuery + slick.min.js + slick CSS were also removed from layout/theme.liquid, so this file
   is now dependency-free. The quote-form logic below is unchanged. */

/* Match Point native quote form — lives in the theme (not the page's body_html) so a
   Shopify page-editor save can never strip it. The rich-text page editor sanitizes raw
   HTML on save and drops <script> tags and data-* attributes; it does not touch theme
   asset files, so this is immune to that. */
(function () {
  var f = document.getElementById('mpq');
  if (!f) return;
  var err = f.querySelector('.mpq-err');
  var btn = f.querySelector('button[type=submit]');
  var origBtnText = btn.textContent;
  var endpoint = 'https://customer-pipeline-tracking-app.vercel.app/api/quote';
  f.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (!f.reportValidity()) return;
    err.hidden = true; btn.disabled = true; btn.textContent = 'Sending…';
    try {
      var res = await fetch(endpoint, { method: 'POST', body: new FormData(f) });
      var data = await res.json();
      if (data && data.ok && data.redirect) { window.location.href = data.redirect; return; }
      throw new Error((data && data.error) || 'Something went wrong');
    } catch (ex) {
      err.textContent = (ex && ex.message) || "Couldn't send — please email info@matchpointpromotions.com";
      err.hidden = false; btn.disabled = false; btn.textContent = origBtnText;
    }
  });
})();

/* Match Point — truncated product-page quote form (snippets/mpq-mini-quote.liquid).
   Same theme-based-JS pattern as the main quote form above: lives here, not in any
   page/product body content, so it's immune to editor sanitization. Handles multiple
   instances defensively even though each product page normally renders just one. */
(function () {
  var endpoint = 'https://customer-pipeline-tracking-app.vercel.app/api/quote';
  /* Shopify product handle → [JotForm "Which product" value, minimum order quantity].
     Values must match the quote form's own <select> options exactly (the Edge
     Protection Tape option really has two spaces). Mirrors the MAP originally built
     for the old redirect-based quick-quote widget this replaces. */
  var MAP = {
    'custom-vibration-dampeners':                ['Tennis Vibration Dampeners', 100],
    'custom-tennis-grip-bands':                   ['Tennis Grip Bands', 100],
    'custom-tennis-overgrips':                    ['Tennis Overgrips', 300],
    'custom-pickleball-grip-bands':                ['Pickleball Grip Bands', 100],
    'custom-pickleball-overgrips':                  ['Pickleball Overgrips', 300],
    'custom-pickleball-eraser':                    ['Pickleball Erasers', 100],
    'custom-pickleball-edge-protection-tape':      ['Pickleball  Edge Protection Tape', 600],
    'custom-pickleball-lead-tape':                  ['Pickleball Lead Tape', 10000],
    'custom-pickleball-bag':                        ['Pickleball Bags', 300],
    'custom-bag-luggage-tags':                      ['Sports Bag Tags', 200],
    'custom-embroidered-terry-cloth-wristbands':    ['Terry Cloth Wristbands', 100],
    'custom-embroidered-terry-cloth-headbands':     ['Terry Cloth Headbands', 100],
    'custom-3d-chrome-car-emblems':                 ['Chrome Emblems', 200],
    'custom-magnets':                               ['Magnets', 200],
    'custom-keychains':                             ['Keychains', 200],
    'custom-bottle-openers':                        ['Bottle Openers', 200],
    'custom-silicone-wristbands':                   ['Silicone Wristbands', 100],
    'custom-padel-overgrips':                       ['Padel Overgrips', 300],
    'custom-badminton-overgrips':                   ['Badminton Overgrips', 300],
    'custom-pickleball-paddle-cap-weights':         ['Pickleball Cap Weights', 300]
  };

  document.querySelectorAll('.mpq-mini__form').forEach(function (f) {
    var wrap = f.closest('.mpq-mini');
    var handle = wrap ? wrap.getAttribute('data-handle') : null;
    var entry = MAP[handle];
    var moq = entry ? entry[1] : 100;
    var qtyEl = f.querySelector('input[name=quantity]');
    if (qtyEl) qtyEl.placeholder = 'Qty (min ' + moq.toLocaleString() + ')';
    var err = f.querySelector('.mpq-mini__err');
    var btn = f.querySelector('button[type=submit]');
    var originalBtnText = btn.textContent;

    f.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (!f.reportValidity()) return;
      err.hidden = true; btn.disabled = true; btn.textContent = 'Sending…';
      try {
        var fd = new FormData(f);
        if (entry) fd.set('product', entry[0]);
        var q = parseInt(fd.get('quantity'), 10);
        if (!(q > 0)) q = moq;
        if (q < moq) q = moq; /* never submit below the product minimum */
        fd.set('quantity', q);
        var res = await fetch(endpoint, { method: 'POST', body: fd });
        var data = await res.json();
        if (data && data.ok && data.redirect) { window.location.href = data.redirect; return; }
        throw new Error((data && data.error) || 'Something went wrong');
      } catch (ex) {
        err.textContent = (ex && ex.message) || "Couldn't send — please email info@matchpointpromotions.com";
        err.hidden = false; btn.disabled = false; btn.textContent = originalBtnText;
      }
    });
  });
})();
